<template v-bind:is="currentTabComponent" >
    <div class="template-page" >
        
        <div class="col-12 mb-4 d-none" >
            <div class="row no-gutters" >
                <div class="col-12" > <h1 class=" page-title" > Hello {{ usergetter }}! </h1> </div>
            </div>
        </div>
        
        <div class="col-12" >
            
            <div class="row" >
                <div class="col-12 col-md-8 my-card-wrapper " >
                    <div class="my-card main-card" >
                        <div class="row no-gutters" >
                            <div class="col-12 col-md-4 d-none" >
                                <line-chart :data="radarChart" :width="450" :height="chartHeight()" color="fff" legend="false" ></line-chart>
                            </div>
                            <div class="col-12" > 
                                <a @click=refreshToday() class="refresh-icon" >  <font-awesome-icon :icon="['fas', 'sync'] "  /> </a>
                                <h2 class="main-title my-card-title" > Hello {{ usergetter }}! <br> This is today's activity </h2> 
                                
                                <div class="row yesterday-stats" >
                
                                    <div class="col-6 col-md-3 my-card-wrapper" >
                                        <div class="my-card my-card-transparent" >
                                            <div class="col-12 my-card-head" > 
                                                <font-awesome-icon :icon="['fas', 'eye'] " class="icon" /> 
                                                <h2 class="my-card-number" >   {{ today.views }} </h2> 
                                            </div>
                                            <div class="col-12 my-card-body" >
                                                <h2 class="my-card-title" > Total views </h2> 
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 col-md-3 my-card-wrapper" >
                                        <div class="my-card my-card-transparent" >
                                            <div class="col-12 my-card-head" > 
                                                <font-awesome-icon icon="user-tie" class="icon" /> 
                                                <h2 class="my-card-number" >   {{ today.visitors }} </h2> 
                                            </div>
                                            <div class="col-12 my-card-body" >
                                                <h2 class="my-card-title" > Unique visitors </h2> 

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 col-md-3 my-card-wrapper" >
                                        <div class="my-card my-card-transparent" >
                                            <div class="col-12 my-card-head" > 
                                                <font-awesome-icon icon="mouse" class="icon" /> 
                                                <h2 class="my-card-number" >   {{ today.clicks }} </h2> 
                                            </div>
                                            <div class="col-12 my-card-body" >
                                                <h2 class="my-card-title" > Link clicks </h2> 
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 col-md-3 my-card-wrapper" >
                                        <div class="my-card my-card-transparent" >
                                            <div class="col-12 my-card-head" > 
                                                <font-awesome-icon icon="link" class="icon" /> 
                                                <h2 class="my-card-number" > {{ today.shortlink_clicks }} </h2> 
                                            </div>
                                            <div class="col-12 my-card-body" >
                                                <h2 class="my-card-title" > Shortlink clicks  </h2> 
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                
                            </div>
                        </div>
                        
                        

                    </div>
                </div> <!-- my-card-wrapper -->
                
                <div class="col-12 col-md-4" >
                    <div class=" my-card-wrapper" >
                        <div class="my-card my-card-table" >
                            <div class="col-12" >  <h2 class="my-card-title mb-2" > Most clicked links </h2> </div>  
                            <div class="col-12 my-card-body" >
                                <div class="the-table" >
                                    <div class="table-body" v-if="isPro"  >

                                            <div v-for="(row, index) in mvplinks" :index="index" :key="index" class="row bordered" >
                                                <div class="col-10 " > 
                                                    <router-link :to="{name: 'LinkStats', params: { linkID: row.linkID }}" > {{ row.name }} </router-link>
                                                </div>  
                                                <div class="col-2" >  <b-badge pill variant="secondary"> {{ row.clicks }} </b-badge>  </div>  
                                            </div>
                                        
                                            

                                    </div>
                                    <div v-else-if="!isPro" class="table-body text-center" > 
                                        <div class="mt-4" > Upgrade to pro for insights on stats and tracking </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
            <div class="row mt-2" >
                
                <div class="col-12 col-md-3 my-card-wrapper" >
                    <div class="my-card my-card-transparent" >
                        <div class="col-12 my-card-head" > 
                            <font-awesome-icon :icon="['fas', 'eye'] "class="icon icon-full" /> 
                            <h2 class="my-card-number" > {{ all.views }} </h2> 
                        </div>
                        <div class="col-12 my-card-body mt-3" >
                            <h2 class="my-card-title" > Total views </h2> 
                            <p class="my-card-description" >
                                Total views ( impressions ) since the beginning of time
                            </p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 my-card-wrapper" >
                    <div class="my-card my-card-transparent" >
                        <div class="col-12 my-card-head" > 
                            <font-awesome-icon icon="user-tie" class="icon icon-full" /> 
                            <h2 class="my-card-number" >   {{ all.visitors }} </h2> 
                        </div>
                        <div class="col-12 my-card-body mt-3" >
                            <h2 class="my-card-title" > Unique visitors </h2> 
                            <p class="my-card-description" >
                                Total unique views ( visitors ) since the beginning of time
                            </p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 my-card-wrapper" >
                    <div class="my-card my-card-transparent" >
                        <div class="col-12 my-card-head" > 
                            <font-awesome-icon icon="mouse" class="icon icon-full" /> 
                            <h2 class="my-card-number" >   {{ all.clicks }} </h2> 
                        </div>
                        <div class="col-12 my-card-body mt-3" >
                            <h2 class="my-card-title" > Link clicks </h2> 
                            <p class="my-card-description" >
                                Total links clicks since the beginning of time
                            </p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 my-card-wrapper" >
                    <div class="my-card my-card-transparent" >
                        <div class="col-12 my-card-head" > 
                            <font-awesome-icon icon="external-link-alt" class="icon icon-full" /> 
                            <h2 class="my-card-number" > {{ all.shortlink_clicks }}  </h2> 
                        </div>
                        <div class="col-12 my-card-body mt-3" >
                            <h2 class="my-card-title" > Shortlink clicks  </h2> 
                            <p class="my-card-description" >
                                Total shortlinks clicks since the beginning of time
                            </p>
                        </div>
                    </div>
                </div>

                
            </div>
            
            <div class="row mb-4" >
                
                <div class="col-12" style="position:relative;" >
                    <date-picker v-model="period" range valueType="format" confirm class="datepicker" @change="refresh_chart" clear-button-icon="false" ></date-picker>
                </div>
                
            </div>
            
            <div class="row " >
                
                <div class="col-12 col-md-6 mb-4 my-card-wrapper" >
                    <div class="my-card" >
                        <div class="col-12" > <h2 class="my-card-title" > Views / Visitors </h2> </div>
                        
                        <line-chart :chart-data="chartProfile" :width="450" :height="220" :options="chartOptions" v-if="isPro" ></line-chart>
                                                
                        <div class="chart-subs isNotPro text-center" v-else-if="!isPro" >
                             Upgrade to pro for insights on stats and tracking
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-6 mb-4 my-card-wrapper" >
                    <div class="my-card" >
                        <div class="col-12" > <h2 class="my-card-title" > Link clicks </h2> </div>
                        <line-chart :chart-data="chartClicks" :width="450" :height="220" :options="chartOptions" v-if="isPro"  ></line-chart>
                        <div class="chart-subs isNotPro text-center" v-else-if="!isPro" >
                             Upgrade to pro for insights on stats and tracking
                        </div>
                    </div>
                </div>
                
            </div>

            
            <div class="row" >
                
                
                
            </div> <!-- .row -->

        </div>

    </div>
</template>

<script>
    
import { AUTH_CHECK, AUTH_LOGOUT } from '../../store/actions/auth'
import lineChart from '../../components/charts/lineChart'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
    

import Cookies from 'js-cookie'
import axios from 'axios'
    
export default {
    name: 'homePage',
    components: {
        DatePicker
    },
    props: {
        
        
    },
    data: function(){
        return {
            timer: '',
            test: '',
            user: '',
            pagetitle: "Dashboard",
            chartProfile:  {},
            chartClicks:  {},
            radarChart: [],
            chartSlClicks:  {},
            chartOptions : {
                responsive: true, 
                maintainAspectRatio: false, 
                legend: {
                    display: true,
                    position: "bottom",
                    align: 'end',
                    fullWidth: false,
                    labels: {
                        boxWidth: 10,
                        fillStyle: "Color",
                        fontSize: 11
                    }
                }, 
                scales: {
                  xAxes: [{
                    gridLines: {
                        display:false
                    }, 
                    ticks: {
                        fontColor: '#000'
                    },
                  }],
                  yAxes: [{
                    gridLines: {
                        display:false
                    },  
                    ticks: {
                        display: false,
                        fontColor: '#fff',
                        beginAtZero: true,
                    }, 
                  }],
                },
                layout: {
                    padding: { top: 10 }
                }
            },
            all: { views: 0, visitors: 0, clicks: 0, shortlink_clicks: 0 },
            today: { views: 0, visitors: 0, clicks: 0, shortlink_clicks: 0 },
            period: [ "", "" ],
            shortcuts: [
                { text: 'today', onClick: () => {
                    let today = this.$moment(Date.now()).format('YYYY-MM-DD');
                    let tomorrow = this.$moment(Date.now() + 1).format('YYYY-MM-DD');

                    let period = [ today, tomorrow ];
                    this.period = period;
                    return period;
                } },
                  {
                    text: 'Yesterday',
                    onClick: () => {
                        let today = this.$moment(Date.now()).format('YYYY-MM-DD');
                        let yesterday = this.$moment(Date.now() - 1 ).format('YYYY-MM-DD');

                        let period = [ yesterday, today];
                        this.period = period;
                        
                        this.period = period;
                        return period;
                    },
                  },
            ],
            mvplinks: [],
            mvpshortlinks: [],
            
        }
    },
    created: function () {
        
    },
    beforeMount(){
    },
    mounted() {      
        //this.getData()
      
        this.init_period()
        //this.getChartData()    
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        getData: function() {
            
            let params = Cookies.get('user-token')
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/stats/dashboard.php', headers: { 'Content-Type': 'text/plain', "X-Auth": params } })
                .then(resp => {
                
                //console.log(resp)
                
                let r = resp.data;

                if( r.status == 100 ){
                    
                    this.all = r.message.all[0];
                    this.today = r.message.today[0];
                    this.mvplinks = r.message.mvp_links;
                    this.mvpshortlinks = r.message.mvp_shortlinks;

                    this.loaded = true;
                    
                }else if( r.status == 101 ){
                    // if resp is unauthorized, logout, to
                    this.$store.dispatch(AUTH_LOGOUT).then(() => { 
                        this.$router.push({ name: 'Login'});
                    })
                }
            }); //end axios  

        },
        init_period(){
            let today = this.$moment(Date.now()).format('YYYY-MM-DD');
            let today_7 = this.$moment(Date.now()).subtract(7,'d').format('YYYY-MM-DD');

            this.period = [ today_7, today ];
        },
        refresh_chart( $event ){
            //this.period = $event;
            if( this.period[0] == null || this.period[1] == null ){
                this.init_period()
            }
            if( this.isPro ){
                this.getChartData( );
            }
                
            
        },
        getChartData( ){
          
            //console.log( this.period )
            
            let params = Cookies.get('user-token')
            
            let data = JSON.stringify({
                "start":  this.period[0],
                "end":  this.period[1]
            })
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/stats/stats.php', headers: { 'Content-Type': 'text/plain', "X-Auth": params }, data: data })
                .then(resp => {

                let r = resp.data;

                if( r.status == 100 ){
                    //console.log( r.message[0] );
                    
                    if( r.message.length > 0 ){
                        let data = r.message;
                        
                        this.processDataChart( data );
                        
                        //this.selectedicon = r.message[0].icon;
                        //this.search = r.message[0].icon;
                        //this.linkColorValue = r.message[0].color;
                        this.loaded = true;
                    }
                    
                }else if( r.status == 101 ){
                    // if resp is unauthorized, logout, to
                    this.$store.dispatch(AUTH_LOGOUT).then(() => { 
                        this.$router.push({ name: 'Login'});
                    })
                }
            }); //end axios  
            
            
        },
        processDataChart( data ){
            //console.log(data);
            
            let dates = [];
            let views = [];
            let visitors = [];
            let clicks = [];
            let slclicks = [];
            
            for( let i = 0; i <= data.length-1; i++ ){
                dates.push( this.$moment( data[i].date ).format('D MMM') )
                views.push( data[i].views )
                visitors.push( data[i].visitors )
                clicks.push( data[i].clicks )
                slclicks.push( data[i].slclicks )
            }
            
            //console.log( dates );
            //this.chartLabels = dates;
            //this.chartProfile = views;
            this.radarChart = clicks;
            
            this.chartProfile = {
                  labels: dates,
                  datasets: [
                    {
                        borderColor: '#3e4cb3',
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        pointBorderColor: '#3e4cb3',
                        backgroundColor: 'rgba(62, 76, 179, 0.3)',
                        label: 'Views',
                        data: views,
                    },
                    {
                        borderColor: '#777',
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        pointBorderColor: '#777',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        label: 'Visitors',
                        data: visitors,
                    }
                  ]
            }
            
            
            this.chartClicks = {
                  labels: dates,
                  datasets: [
                    {
                        borderColor: '#3e4cb3',
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        pointBorderColor: '#3e4cb3',
                        backgroundColor: 'rgba(62, 76, 179, 0.3)',
                        label: 'Cicks',
                        data: clicks,
                    }
                  ]
            }
            
            //console.log( this.chartLabels );
            
        },        
        refreshToday: function() {
            
            this.getData()

        },
        cancelAutoUpdate: function() {
            clearInterval(this.timer) 
        },
        alertDisplay() {
            this.$swal({
            title: '<i>Custom HTML</i>',
            // add a custom html tags by defining a html method.
            html:
            'This is an <em> emaphazied text </em>, ' +
            '<a href="#">links</a> ' +
            '<strong>And other tags</strong>',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            })

        }, //end alertDisplay
        chartHeight(){
            let width = window.innerWidth
            //console.log( width )
            if( width < 767 ){
                return 150;
            }else{
                return 200;
            }
            
        },
    },
    computed: {
        usergetter(){
            //console.log( this.$store.getters.getFirstname );
            return this.$store.getters.getFirstname
        },
        isPro(){
            //console.log( this.$store.getters.getPro )
            return this.$store.getters.getPro
            //return false
        },
        userOnboarding(){
            console.log(this.$store.getters.getOnboarding )
            return this.$store.getters.getOnboarding 
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
</style>



// WEBPACK FOOTER //
// src/templates/home/Home.vue